var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import isBefore from 'date-fns/isBefore';
import React, { forwardRef, useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Calendar as CalendarIcon } from '@creditornot/cb-icons';
import { Input } from '@creditornot/cb-input';
import DatePickerPopover from './DatePickerPopover';
import DateRangePicker from './DateRangePicker';
import { defaultLocale, getLocaleCode } from './utils';
var DatePickerContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 4px 16px 20px 16px;\n"], ["\n  padding: 4px 16px 20px 16px;\n"])));
var StyledInput = styled(Input)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  min-width: ", "px;\n"], ["\n  min-width: ", "px;\n"])), function (_a) {
    var onClearClick = _a.onClearClick;
    return (onClearClick ? 240 : 220);
});
var DateRangePickerInput = function (_a, ref) {
    var children = _a.children, className = _a.className, disableClear = _a.disableClear, disabled = _a.disabled, disabledDays = _a.disabledDays, disableMonthChange = _a.disableMonthChange, disableOutsideDaysClick = _a.disableOutsideDaysClick, disableYearSelect = _a.disableYearSelect, formatValue = _a.formatValue, _b = _a.inputIcon, inputIcon = _b === void 0 ? React.createElement(CalendarIcon, null) : _b, inputRef = _a.inputRef, invalid = _a.invalid, _c = _a.locale, locale = _c === void 0 ? defaultLocale : _c, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, placeholder = _a.placeholder, popoverPlacement = _a.popoverPlacement, popoverPortalElement = _a.popoverPortalElement, popoverRendering = _a.popoverRendering, popoverZIndex = _a.popoverZIndex, renderDayDotIndicator = _a.renderDayDotIndicator, rootRef = _a.rootRef, showOutsideDays = _a.showOutsideDays, style = _a.style, timezone = _a.timezone, value = _a.value;
    var IntlDateTimeFormat = useMemo(function () {
        var options = timezone ? { timeZone: timezone } : undefined;
        return new Intl.DateTimeFormat(getLocaleCode(locale), options);
    }, [locale, timezone]);
    var _d = __read(useState(undefined), 2), firstSelection = _d[0], setFirstSelection = _d[1];
    var valueToShow = useMemo(function () { return (firstSelection ? { from: firstSelection } : value); }, [firstSelection, value]);
    var defaultFormatValue = useCallback(function (value) {
        if (!value.from && !value.to) {
            return '';
        }
        return "".concat(value.from ? IntlDateTimeFormat.format(value.from) : '', " \u2013 ").concat(value.to ? IntlDateTimeFormat.format(value.to) : '');
    }, [IntlDateTimeFormat]);
    var formattedValue = value
        ? (formatValue || defaultFormatValue)(value, { timeZone: timezone })
        : '';
    return (React.createElement(DatePickerPopover, { content: function (_a) {
            var closePopover = _a.closePopover;
            return (React.createElement(DatePickerContainer, null,
                React.createElement(DateRangePicker, { disableMonthChange: disableMonthChange, disableOutsideDaysClick: disableOutsideDaysClick, disableYearSelect: disableYearSelect, disabledDays: disabledDays, locale: locale, onDayClick: function (day) {
                        if (firstSelection === undefined) {
                            setFirstSelection(day);
                        }
                        else {
                            onChange(isBefore(firstSelection, day)
                                ? { from: firstSelection, to: day }
                                : { from: day, to: firstSelection });
                            setFirstSelection(undefined);
                            closePopover();
                        }
                    }, renderDayDotIndicator: renderDayDotIndicator, showOutsideDays: showOutsideDays, timezone: timezone, value: valueToShow })));
        }, contentZIndex: popoverZIndex, disabled: disabled, onCloseStart: onBlur, placement: popoverPlacement, portalElement: popoverPortalElement, rendering: popoverRendering }, children
        ? function (props) { return children(__assign(__assign({}, props), { value: value, formattedValue: formattedValue })); }
        : function () { return (React.createElement(StyledInput, { className: className, disabled: disabled, icon: inputIcon, invalid: invalid, onClearClick: disableClear
                ? undefined
                : function () {
                    if (onChange) {
                        onChange(undefined);
                    }
                }, onFocus: function (event) {
                setFirstSelection(undefined);
                if (onFocus) {
                    onFocus(event);
                }
            }, placeholder: placeholder, readOnly: true, ref: ref !== null && ref !== void 0 ? ref : inputRef, rootRef: rootRef, style: style, value: formattedValue })); }));
};
export default forwardRef(DateRangePickerInput);
var templateObject_1, templateObject_2;
//# sourceMappingURL=DateRangePickerInput.js.map